// Controls parent-dependent checkbox relationships where unchecking a parent checkbox
// unchecks and disables all dependent checkboxes, and checking it re-enables them.
//
// Usage:
// Add data-controller="kegs--dependent-enabled-checkbox" to a container element, then add
// data-kegs--dependent-enabled-checkbox-target="parentCheckbox" to the main checkbox and
// data-kegs--dependent-enabled-checkbox-target="dependentCheckbox" to each dependent checkbox.
// Wire up data-action="change->kegs--dependent-enabled-checkbox#updateDependentCheckboxState"
// on the parent checkbox element.
//
// Behavior:
// When parent checkbox is checked: dependent checkboxes are enabled (user can interact)
// When parent checkbox is unchecked: dependent checkboxes are unchecked and disabled
// State is initialized on connect - dependents are unchecked and disabled if parent starts unchecked
//
// Notes:
// Includes MDL (Material Design Lite) compatibility by dispatching change events
// to update visual checkbox states after programmatic changes.
//

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["parentCheckbox", "dependentCheckbox"]

  connect() {
    if(!this.parentCheckboxTarget.checked) {
      this.uncheckAndDisableDependents()
    }
  }

  updateDependentCheckboxState() {
    if(this.parentCheckboxTarget.checked) {
      this.enableDependents()
    } else {
      this.uncheckAndDisableDependents()
    }
  }

  enableDependents() {
    this.dependentCheckboxTargets.map((dependent) => {
      dependent.disabled = false
    })
    this.mdlUpgradeCheckboxes()
  }

  uncheckAndDisableDependents() {
    this.dependentCheckboxTargets.map((dependent) => {
      dependent.checked = false
      dependent.disabled = true
    })
    this.mdlUpgradeCheckboxes()
  }

  // Required to visually change the state of MDL checkboxes
  mdlUpgradeCheckboxes() {
    const evt = new Event("change")
    this.dependentCheckboxTargets.map(dependent => dependent.dispatchEvent(evt))
  }

}
